import * as Sentry from "@sentry/react";

import { env } from "@/env";

export const captureException = (error: unknown) => {
  if (env.VITE_APP_ENV === "production") {
    Sentry.captureException(error);
  } else {
    // eslint-disable-next-line no-console
    console.error(error);
  }
};
